export const STOCK_TRANSFERS_RESET_STATE = 'STOCK_TRANSFERS_RESET_STATE';
export const STOCK_TRANSFERS_CURRENT_ITEM = 'STOCK_TRANSFERS_CURRENT_ITEM';

export const STOCK_TRANSFERS_REQUEST_LOADING = 'STOCK_TRANSFERS_REQUEST_LOADING';
export const STOCK_TRANSFERS_REQUEST_SUCCESS = 'STOCK_TRANSFERS_REQUEST_SUCCESS';
export const STOCK_TRANSFERS_REQUEST_FAILED = 'STOCK_TRANSFERS_REQUEST_FAILED';

export const STOCK_TRANSFERS_CURRENT_ACTION = 'STOCK_TRANSFERS_CURRENT_ACTION';
export const STOCK_TRANSFERS_RESET_ACTION = 'STOCK_TRANSFERS_RESET_ACTION';
